import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import Header from './Header';
import Footer from './Footer';
import { saveB2bLogin, saveB2bRegister } from '../services/services';

const B2BPortal = () => {
    const [isLogin, setIsLogin] = useState(true);
    const [loginData, setLoginData] = useState({ email: '', password: '' });
    const [registerData, setRegisterData] = useState({
        businessName: '', businessNumber: '', businessAddress: '',
        tradingName: '', businessType: '', contactName: '',
        contactEmail: '', contactPhone: '', designation: '',
        productsInterested: '', avgFlightBookings: '', avgHotelBookings: ''
    });
    const navigate = useNavigate();

    const handleLoginChange = (e) => setLoginData({ ...loginData, [e.target.name]: e.target.value });
    const handleRegisterChange = (e) => setRegisterData({ ...registerData, [e.target.name]: e.target.value });

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        saveB2bLogin(
            loginData,
            (data) => {
                if (data.token) {
                    localStorage.setItem('b2bToken', data.token);
                    localStorage.setItem('b2bUser', JSON.stringify(data.user));
                    toast.success('Login successful!');
                    navigate(-1); // Go back to original booking attempt
                }
            },
            (error) => {
                toast.error(error.response?.data?.error || 'Login failed');
            }
        );
    };

    const handleRegisterSubmit = async (e) => {
        e.preventDefault();
        saveB2bRegister(
            registerData,
            (data) => {
                toast.success('Registration submitted! We will contact you soon.');
                setIsLogin(true);
            },
            (error) => {
                toast.error(error.response?.data?.error || 'Registration failed');
            }
        );
    };

    return (
        <>
            <Header />
            <div className="container mt-5 mb-5" style={{ minHeight: '60vh' }}>
                <div className="row justify-content-center">
                    <div className="col-md-8 offset-md-2 mt-5">
                        <div className="card shadow-sm mt-5">
                            <div className="card-header d-flex justify-content-around">
                                <button className={`btn w-50 ${isLogin ? 'btn-primary' : 'btn-light'}`} onClick={() => setIsLogin(true)}>Login</button>
                                <button className={`btn w-50 ${!isLogin ? 'btn-primary' : 'btn-light'}`} onClick={() => setIsLogin(false)}>Register</button>
                            </div>
                            <div className="card-body">
                                {isLogin ? (
                                    <form onSubmit={handleLoginSubmit}>
                                        <h4 className="mb-4">B2B Portal Login</h4>
                                        <div className="mb-3">
                                            <label>Email</label>
                                            <input type="email" name="email" className="form-control" required onChange={handleLoginChange} />
                                        </div>
                                        <div className="mb-3">
                                            <label>Password</label>
                                            <input type="password" name="password" className="form-control" required onChange={handleLoginChange} />
                                        </div>
                                        <button type="submit" className="btn btn-primary w-100 mt-2">Login</button>
                                    </form>
                                ) : (
                                    <form onSubmit={handleRegisterSubmit}>
                                        <h4 className="mb-4">B2B Partner Registration</h4>

                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label>Registered Business Name *</label>
                                                <input type="text" name="businessName" className="form-control" required onChange={handleRegisterChange} />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label>Business Number *</label>
                                                <input type="text" name="businessNumber" className="form-control" required onChange={handleRegisterChange} />
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <label>Business Address *</label>
                                            <textarea name="businessAddress" className="form-control" required onChange={handleRegisterChange}></textarea>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label>Trading as Name (If Any)</label>
                                                <input type="text" name="tradingName" className="form-control" onChange={handleRegisterChange} />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label>Business Type *</label>
                                                <input type="text" name="businessType" className="form-control" placeholder="OTA, Agent, etc" required onChange={handleRegisterChange} />
                                            </div>
                                        </div>

                                        <h5>Contact Details</h5>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label>Name *</label>
                                                <input type="text" name="contactName" className="form-control" required onChange={handleRegisterChange} />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label>Email *</label>
                                                <input type="email" name="contactEmail" className="form-control" required onChange={handleRegisterChange} />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label>Phone *</label>
                                                <input type="text" name="contactPhone" className="form-control" required onChange={handleRegisterChange} />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label>Designation *</label>
                                                <input type="text" name="designation" className="form-control" required onChange={handleRegisterChange} />
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <label>Products / Services Interested In *</label>
                                            <select name="productsInterested" className="form-select" required onChange={handleRegisterChange}>
                                                <option value="">Select Option</option>
                                                <option value="Flights">Flights</option>
                                                <option value="Hotels">Hotels</option>
                                                <option value="Both">Both</option>
                                            </select>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label>Avg Bookings per month (Flights)</label>
                                                <input type="number" name="avgFlightBookings" className="form-control" onChange={handleRegisterChange} />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label>Avg Bookings per month (Hotels)</label>
                                                <input type="number" name="avgHotelBookings" className="form-control" onChange={handleRegisterChange} />
                                            </div>
                                        </div>

                                        <button type="submit" className="btn btn-primary w-100 mt-2">Submit Application</button>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default B2BPortal;
